export default "__VITE_ASSET__M5k86u6$__"